import React, { Component, Fragment } from 'react'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

import Navigation from '../layouts/Navigation'

import FilterList from '../components/FilterList'

import withGeneralTranslations from '../hocs/withGeneralTranslations'
import withWebToPrint from '../hocs/withWebToPrint'

import withSellerInformation from './helpers/withSellerInformation'

import Heading3 from '../styleguide/Heading3'

import { NAVIGATION_HEIGHT } from '../layouts/Navigation'

import PrintContainer from './PrintContainer'

const styles = theme => ({
  containerStyle: {
    maxWidth: 1200,
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media print': {
      display: 'none'
    }
  }
})

class SellerInformation extends Component {
  componentWillUnmount() {
    this.props.endWebToPrintMode()
  }

  render() {
    const {
      generalTranslations,
      contentSelectedForPrint,
      classes: { containerStyle }
    } = this.props

    return (
      <Fragment>
        <Navigation
          enableWebToPrint
          contentSelectedForPrint={contentSelectedForPrint}
        />
        <div
          style={{
            flex: '1 0 auto',
            background: '#fafafa',
            paddingTop: NAVIGATION_HEIGHT
          }}
        >
          <div
            style={{
              height: 70,
              borderBottom: '1px solid #d6d8db',
              paddingLeft: 35,
              paddingRight: 35
            }}
          >
            <Grid
              container
              className={containerStyle}
              spacing={0}
              alignItems="center"
            >
              <Grid item xs>
                <Heading3 bold>
                  {generalTranslations('customer-benefits')}
                </Heading3>
              </Grid>
              <Grid item xs>
                <Heading3 bold>{generalTranslations('topics')}</Heading3>
              </Grid>
              <Grid item xs>
                <Heading3 bold>{generalTranslations('components')}</Heading3>
              </Grid>
            </Grid>
          </div>
          <div
            style={{
              flex: 1,
              padding: '17px 35px'
            }}
          >
            <List {...this.props} />
          </div>
          <PrintContainer contentSelectedForPrint={contentSelectedForPrint} />
        </div>
      </Fragment>
    )
  }
}

const SellerInformationWithStyles = withStyles(styles)(SellerInformation)

const List = ({
  contentFilter,
  setContentFilter,
  resetContentFilter,
  customerBenefits,
  topics,
  components,
  match: { params },
  classes: { containerStyle },

  webToPrintModeActive,
  contentSelectedForPrint,
  toggleContentForPrint
}) => {
  const toggleContentFilter = (type, id) => {
    if (id === contentFilter.id) {
      resetContentFilter()
    } else {
      setContentFilter(params.vehicleSlug, type, id)
    }
  }

  return (
    <Grid container className={containerStyle} spacing={0}>
      <Grid item xs>
        <FilterList
          data={customerBenefits}
          selectedItemId={contentFilter.id}
          onItemSelected={id => {
            toggleContentFilter('customer-benefit', id)
          }}
          webToPrintModeActive={webToPrintModeActive}
          contentSelectedForPrint={contentSelectedForPrint['customer-benefit']}
          onToggleForPrint={item =>
            toggleContentForPrint('customer-benefit', item)
          }
        />
      </Grid>
      <Grid item xs>
        <FilterList
          data={topics}
          selectedItemId={contentFilter.id}
          onItemSelected={id => {
            toggleContentFilter('topic', id)
          }}
          webToPrintModeActive={webToPrintModeActive}
          contentSelectedForPrint={contentSelectedForPrint['topic']}
          onToggleForPrint={item => toggleContentForPrint('topic', item)}
        />
      </Grid>
      <Grid item xs>
        <FilterList
          data={components}
          selectedItemId={contentFilter.id}
          onItemSelected={id => {
            toggleContentFilter('component', id)
          }}
          webToPrintModeActive={webToPrintModeActive}
          contentSelectedForPrint={contentSelectedForPrint['component']}
          onToggleForPrint={item => toggleContentForPrint('component', item)}
        />
      </Grid>
    </Grid>
  )
}

export default compose(
  withGeneralTranslations,
  withSellerInformation,
  withWebToPrint
)(SellerInformationWithStyles)



// WEBPACK FOOTER //
// ./src/screens/SellerInformation.js